export const searchGroupInitialState = {
  filters: {
    name: "",
    city: "",
    country: "",
    categories: "",
    categoryNames: "",
    searchings: "",
    searchingNames: "",
    interests: "",
    interestNames: "",
    rating: "",
  },
  currentPage: 1,
  totalPages: 1,
  groups: [],
  isGroupListLoading: false,
};

export const searchGroupReducer = (state, action) => {
  switch (action.type) {
    case "SET_GROUP_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
        currentPage: 1, // reset to page 1 when filters change
      };
    case "SET_GROUP_PAGE":
      return { ...state, currentPage: action.payload };
    case "SET_GROUP_DATA":
      return {
        ...state,
        groups: action.payload,
        isGroupListLoading: false,
      };
    case "SET_GROUP_TOTAL_PAGES":
      return { ...state, totalPages: action.payload };
    case "SET_GROUP_LOADING":
      return { ...state, isGroupListLoading: action.payload };
    case "RESET_GROUP_FILTERS":
      return {
        ...searchGroupInitialState,
      };
    default:
      return state;
  }
};
